import { Injectable } from '@angular/core';

import { WidgetType } from '@frontend/sports/types/components/widget';
import { OnFeatureInit } from '@frontend/vanilla/core';

import { WidgetRegistryService } from '../../widget/core/widget-registry.service';
import { TopEventsWidgetComponent } from './top-events-widget.component';

@Injectable()
export class WidgetRegistrationService implements OnFeatureInit {
    constructor(private registry: WidgetRegistryService) {}

    onFeatureInit(): void {
        this.registry.registerLazy(WidgetType.TopEvents, TopEventsWidgetComponent);
    }
}
